// src/theme/breakpoints.js
export const BP = {
  tiny: 640,
  tablet: 980,
  desktop: 1200,
  headerCollapse: 1710,
};


